import apiClient from "../network/apiClient";

class CheckoutApiProvider {
  async checkout(input) {
    try {
      const response = await apiClient.post("orders", input);
      if ((response.status == 200 || response.status == 201) && response) {
        return {
          status: true,
          response: response.data
        };
      } else {
        return {
          status: false,
          message: response.data?.message || "Failed to place order",
          response: []
        };
      }
    } catch (error) {
      return {
        status: false,
        message: error.response?.data?.message || error.message || "An error occurred while placing the order",
        response: []
      };
    }
  }
  async paymentverify(input) {
    try {
      const response = await apiClient.post("cart-detail/nomodWebhook", input);
      if (response.status == 200 || response.status == 201 && response) {
        return {
          status: response.status,
          response: response.data
        };
      } else {
        return {
          status: false,
          response: []
        };
      }
    } catch (error) {
      return {
        status: false,
        response: []
      };
    }
  }

  async verifyCheck(input) {
    console.log(input, "iiiii");

    try {
      const response = await apiClient.post("cart-detail/verify-check", input);
      if (response.status == 200 || response.status == 201 && response) {
        return {
          status: response.status,
          response: response.data
        };
      } else {
        return {
          status: false,
          response: []
        };
      }
    } catch (error) {
      return {
        status: false,
        response: []
      };
    }
  }

  async createPayment(input) {
    try {
      const response = await apiClient.post("payment/create", input);
      if ((response.status == 200 || response.status == 201) && response) {
        return {
          status: true,
          redirectUrl: response.data?.data?.redirectUrl,
          response: response.data
        };
      } else {
        return {
          status: false,
          message: response.data?.message || "Failed to initiate payment",
          response: []
        };
      }
    } catch (error) {
      return {
        status: false,
        message: error.response?.data?.message || error.message || "An error occurred during payment initiation",
        response: []
      };
    }
  }
}
const apiCheckout = new CheckoutApiProvider()
export default apiCheckout